import { Box, Button, Card, CardContent, Checkbox, Divider, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography } from '@mui/material';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ReadylyHeader from '../../components/ReadylyHeader/ReadylyHeader.jsx';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { React, useCallback, useEffect, useState } from 'react'
import { useTheme, useMediaQuery } from '@mui/material';
import { Link, useLocation } from 'react-router';
import logo from '../../images/readyly_logo.png'
import ROUTES from '../../constants/routes.js';
import { useAuth } from '../../utils/auth.js';
import { useDispatch } from 'react-redux';
import { getOrgData } from '../../api.js';


const Login = () => {
    const auth = useAuth();
    const location = useLocation()
    const redirectPath = location.state?.path ?? ROUTES.INDEX
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [rememberPassword, setRememberPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const queryParams = new URLSearchParams(location.search);
    const subDomain = queryParams.get('subDomain');

    useEffect(() => {
        dispatch(getOrgData(subDomain))
    }, [subDomain, dispatch])

    const handleSubmit = useCallback(
        async (event) => {
            event.preventDefault();
            if (!event.target.checkValidity()) {
                event.stopPropagation();
                return;
            }
            auth.login(email.toLowerCase(), password, setIsLoading, redirectPath);
        },
        [auth, email, password, redirectPath, setIsLoading]
    );


    return (
        <div>
            <ReadylyHeader />
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: isMobile ? "90%" : "30%", marginTop: "10%", padding: "15px", borderRadius: "30px" }}>
                    <img src={logo} alt="Readyly Logo" width="15%" height="15%" />
                    <CardContent>
                        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                            Powering speed and accuracy
                        </Typography>
                    </CardContent>
                    <Divider variant="fullWidth" sx={{ color: "text.primary" }} />
                    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", alignItems: "center", justifyContent: "center" }} >
                            <FormControl required fullWidth variant="outlined" size="small" sx={{ textTransform: "none" }}>
                                <InputLabel htmlFor="outlined-adornment-password">Email</InputLabel>
                                <OutlinedInput
                                    type="email"
                                    value={email}
                                    fullWidth
                                    sx={{ textTransform: "none" }}
                                    onChange={(event) => setEmail(event.target.value.trim())}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton edge="end" >
                                                <EmailOutlinedIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Email"
                                />
                            </FormControl>
                            <FormControl required fullWidth variant="outlined" size="small" sx={{ textTransform: "none" }}>
                                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                <OutlinedInput
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    fullWidth
                                    sx={{ textTransform: "none" }}
                                    onChange={(event) => setPassword(event.target.value)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" >
                                                {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Password"
                                />
                            </FormControl>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <FormControlLabel control={<Checkbox size="small" checked={rememberPassword} onChange={(e) => setRememberPassword(e.target.checked)} />} label="Remember Me" />
                                <Link to={ROUTES.AGENT.FORGOT_PASSWORD} style={{ fontSize: '0.9rem', textDecoration: "none", textTransform: "none", color: theme.palette.primary.main }}>
                                    Forgot Password?
                                </Link>
                            </div>
                            <Button type="submit" disabled={isLoading || (email.trim() === "" || password.trim() === "")} loading={isLoading} loadingPosition="end" variant="contained" sx={{ textTransform: "none", maxWidth: "30%" }} endIcon={<LoginOutlinedIcon />} >Login</Button>
                        </Box>
                    </form>
                </Card>
            </div>
        </div>
    )
}

export default Login